import { ColorScheme } from "../color-scheme"
import { MapWaypoint } from "./mapping"
import { Point } from "./point"

export class PathWaypoint {
    _id: string
    pathId: string
    pointId: string
    fromPointId: string
    waypointOrder: number
    segment: string
    type: string
    updatedAt?: number
    _rev?: string
}

export const sortByNumericWaypointOrder = (a:PathWaypoint,b:PathWaypoint)=>Number(a?.waypointOrder)-Number(b?.waypointOrder)


export class WaypointTableRow {
    id: string
    pointId: string
    waypointOrder: number
    markerColor: string
    latitude: number
    longitude: number
  
    // tacking these 3 on as hack for CesiumJS mapping (3D)
    altitudeEllipsoidMeters: number
    buildingId: string
    floor: string
  
    segment: string
    type: string
  
    constructor( public mapWaypoint: MapWaypoint ) {
      this.id = mapWaypoint.id
      this.pointId = mapWaypoint.pointId
      this.type = mapWaypoint.type
      this.segment = mapWaypoint?.pathWaypoint?.segment
      this.waypointOrder = Number(mapWaypoint.pathWaypoint?.waypointOrder)
      this.markerColor = ColorScheme.pointColorForIndex(this.waypointOrder)
    }
  
    setPoint( point: Point ) {
      this.mapWaypoint.point = point
      this.latitude = point?.latitude
      this.longitude = point?.longitude;
      this.altitudeEllipsoidMeters = point?.altitudeEllipsoidMeters;
      this.buildingId = point?.buildingId;
      this.floor = point?.floorName ?? point?.floorNum;
    }
  }